import { ReactElement, useState } from "react";
import {
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Divider,
} from "@mui/material";

export interface DEGenesMarkersFormProps {
  onClose?: () => void;
  onSubmit?: (data: DEGenesMarkersData) => void;
  onBack?: () => void;
  onContinue?: () => void;
  className?: string;
}

export interface DEGenesMarkersData {
  method: string;
  additionalParams?: Record<string, any>;
}

const DEGenesMarkersForm = ({
  onClose,
  onSubmit,
  onBack,
  onContinue,
  className = "",
}: DEGenesMarkersFormProps): ReactElement => {
  const [formData, setFormData] = useState<DEGenesMarkersData>({
    method: "t-test",
  });

  const handleInputChange =
    (field: keyof DEGenesMarkersData) =>
    (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | any,
    ) => {
      const value = event.target.value;
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSubmit?.(formData);
  };

  return (
    <Box className={`flex flex-col h-full ${className}`}>
      <Box className="flex-1 p-6">
        <Typography variant="body1" className="mb-6 text-gray-600">
          Identify genes that differ between biological groups and evaluate
          which genes have potential to distinguish those groups using machine
          learning. Results are candidate biomarkers for further investigation.
        </Typography>

        <form onSubmit={handleSubmit} className="space-y-6">
          <FormControl fullWidth>
            <InputLabel>Method</InputLabel>
            <Select
              value={formData.method}
              onChange={handleInputChange("method")}
              label="Method"
              sx={{ backgroundColor: "white" }}
            >
              <MenuItem value="t-test">t-test</MenuItem>
              <MenuItem value="t-test_overestim_var">
                t-test overestimating variance
              </MenuItem>
              <MenuItem value="wilcoxon">Wilcoxon rank-sum</MenuItem>
              <MenuItem value="logreg">Logistic regression</MenuItem>
            </Select>
          </FormControl>

          <Divider className="my-4" />
        </form>
      </Box>

      <Box className="flex justify-between items-center p-6 border-t">
        <Button variant="outlined" color="primary" onClick={onBack}>
          Back
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default DEGenesMarkersForm;
